import { createBrowserRouter } from 'react-router-dom';

// project-imports
import Loadable from 'components/Loadable';
import { lazy } from 'react';
const PortfolioPage = Loadable(lazy(() => import('views/portfolio')));

// ==============================|| ROUTING RENDER ||============================== //

const router = createBrowserRouter(
  [
    {
      path: '/',
      index: true,
      element: <PortfolioPage />
    }
  ],
  {
    basename: import.meta.env.VITE_APP_BASE_NAME === '/' ? '' : import.meta.env.VITE_APP_BASE_NAME
  }
);

export default router;
